// extracted by mini-css-extract-plugin
export var boxItems = "_8l-1";
export var button = "_8l-5";
export var filterGroupBox = "_8l-0";
export var icon = "_8l-2";
export var iconSecondary = "_8l-4";
export var iconWrapper = "_8l-3";